import { Get, HttpPost, Post } from "../utils/ApiUtility";

export const LiveBroadCastListService = () => {
  const getToken = () => localStorage.getItem('DuoLink_token');

  const getLiveBroadcastListWeb = async (page) => {
    const token = getToken();
    const headers = {
      appid: "22",
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    return await Get(`live-broadcast-list-web?page=${page}`, headers);
  };

  const getDialCallRequest = async (userId) => {
    const token = getToken();
    const headers = {
      appid: "22",
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    return await Get(`dialCallZegoSendNotification?receiver_user_id=${userId}`, headers);
  };

  const coinPerSecondUserBusyNewLatest = async (model) => {
    const token = getToken();
    const headers = {
      appid: "22",
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    return await Post('coin-per-second-user-busy-new-latest', model, headers);
  }

  const getLiveBroadcastListWebPublic = async (page) => {
    const headers = {
      'Content-Type': 'application/json'
    };
    return await Get(`live-broadcast-list-web-public?page=${page}`, headers);
  };

  const getcategoryGiftsauth = async () => {
    const token = getToken();
    const header = {
      appid: "22",
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    return await Get('getcategoryGiftsauth', header);
  };

  const sendLuckyGift = async (giftModel) => {
    const token = getToken();
    const header = {
      appid: "22",
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    return await Post('send_lucky_gift', giftModel, header);
  };

  const GenerateZegoTokenInWeb = async () => {
    const header = {
      appid: "22",
      'Content-Type': 'application/json'
    }
    return await Get('generate-zego-token-in-web', header);
  };

  const dialCallZegoSendNotification = async (params) => {
    const token = getToken();
    const header = {
      appid: "22",
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    const query = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
    return await Get(`dialCallZegoSendNotificationLatest?${query}`, header);
  };

  const callCutByUserSideAndSendNotification = async (connectingUserId) => {
    const token = getToken();
    return await HttpPost(`call-cut-by-userside-send-notification`, connectingUserId,token);
  };

  const updateFCMToken = async (fcmToken) => {
    const token = getToken();
    const data = { token: fcmToken, app_version: 1.0 };
    const header = {
      appid: "22",
      authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    return await Post('updateFCMToken', data, header);
  };

  return {updateFCMToken, getLiveBroadcastListWeb, getDialCallRequest, coinPerSecondUserBusyNewLatest, getLiveBroadcastListWebPublic, getcategoryGiftsauth, sendLuckyGift, GenerateZegoTokenInWeb, dialCallZegoSendNotification,callCutByUserSideAndSendNotification }

}
